import { Component, Input, OnInit } from '@angular/core';
import { Tenant } from '../../../../model/tenant';
import { TenantsService } from '../../../../services/tenants.service';
import { Organization } from '../../../../model/organization';

@Component({
  selector: 'app-tenant-organizations',
  templateUrl: './tenant-organizations.component.html',
  styleUrls: ['./tenant-organizations.component.scss']
})
export class TenantOrganizationsComponent implements OnInit {

  @Input()
  public tenant: Tenant;

  public organizations: Organization[];
  public totalOrganizations: number;
  public loadingOrganizations: boolean;

  public rows = 10;
  public first = 0;

  constructor(private tenantsService: TenantsService) {}

  ngOnInit(): void {
    this.loadOrganizations(this.first / this.rows, this.rows);
  }

  private loadOrganizations(offset: number, limit: number): void {
    this.loadingOrganizations = true;
    this.tenantsService.getTenantOrganizations(this.tenant.uuid, offset, limit)
      .subscribe(response => {
        this.organizations = response.organizations.sort((a, b) => a.name > b.name ? 1 : -1);
        this.totalOrganizations = response.totalElements;
        this.loadingOrganizations = false;
      });
  }

  onPageChange(event): void {
    this.loadOrganizations(event.first / event.rows, event.rows);
  }

}
